export function createPublishMethods(api) {
    return {
        async publish(campaignId) {
            const {data} = await api.gamemasterCampaignsPublishCreate(campaignId, {});
            return data;
        },
    };
}
